<div class="form-group">
  <label for="prod-m">{{ 'form.usageType'| translate }}</label>
  <angular2-multiselect [data]="typeList"
      [(ngModel)]="typeSelected"
      [settings]="multiselectSettings[EMULTI_SELECT_SETTING.NO_SEARCH]"
      (onSelect)="onTypeSelect()">
  </angular2-multiselect>
</div>